import * as React from 'react';
import gql from 'graphql-tag';
import { ChildProps, graphql, compose } from 'react-apollo';

const EshopsQuery = gql`
    query {
        eshops {
            id
            domain
            name
        }
    }
`;

interface IInputProps {
    children?: any;
}

interface Response {
    data: any;
}

class GetEshopsQuery extends React.Component<ChildProps<IInputProps, Response>, {}> {
    render() {
        const { eshops }: any = this.props;
        return this.props.children({
            eshops
        });
    }
}

export default compose(
    graphql<IInputProps, Response>(EshopsQuery, {
        name: 'eshops'
    })
)(GetEshopsQuery);



// WEBPACK FOOTER //
// ./src/components/Query/Eshops/Eshops.tsx